import React from 'react'
import { Link } from 'react-router-dom'

import Navbar from '../../components/navbar'
import VideoModalOne from '../../components/video-modal-one'
import FooterLight from '../../components/footer-light'
import Partner from '../../components/partner'
import ClientThree from '../../components/client-three'

import bg1 from '../../assets/images/marketing/marketing.png'
import heroImg from '../../assets/images/marketing/Degital_marketing_SVG.svg'
import fea1 from '../../assets/images/marketing/01.png'
import fea2 from '../../assets/images/marketing/02.png'

import { marketingFeature } from '../../data/data'

import {LiaRulerCombinedSolid, BiBullseye, LuUser2, BsFonts} from '../../assets/icons/vander'

export default function IndexMarketing() {
  return (
    <>
     <Navbar/> 

    <section className="bg-half-170 bg-light d-table w-100" style={{backgroundImage:`url(${bg1})`}}>
      <div className="container">
          <div className="row align-items-center">
              <div className="col-lg-7 col-md-7">
                  <div className="title-heading mt-4">
                      <h1 className="heading mb-3">Get Ready for Digital Marketing</h1>
                      <p className="para-desc text-muted">Start work with <span className="text-primary">Leaping</span>. Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                      <div className="watch-video mt-4 pt-2">
                          <Link to="#" className="btn btn-primary mb-2 me-2">Get Started</Link>
                          <div className="watch-video mt-4 pt-2 d-inline-block">
                              <VideoModalOne/>
                          </div>
                      </div>
                  </div>
              </div>
              <div className="col-lg-5 col-md-5 mt-4 pt-2 mt-sm-0 pt-sm-0">
                  <img src={heroImg} alt=""/>
              </div>
          </div>
      </div>
    </section>

    <section className="section border-top">
      <div className="container">
          <Partner/>
      </div>
      <div className="container mt-100 mt-60">
          <div className="p-4 rounded shadow">
              <div className="row align-items-center">
                  <div className="col-sm-7">
                      <div className="text-sm-start">
                          <h4 className="mb-0">Start building beautiful block-based websites.</h4>
                      </div>
                  </div>

                  <div className="col-sm-5 mt-4 mt-sm-0">
                      <div className="text-sm-end">
                          <Link to="#" className="btn btn-outline-primary"><i className="mdi mdi-file-document-outline"></i> Register Today</Link>
                      </div>
                  </div>
              </div>
          </div>
      </div>

      <div className="container mt-100 mt-60">
          <div className="row">
            {marketingFeature.map((item,index)=>{
              let Icon = item.icon
              return(
                  <div className="col-md-4 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0" key={index}>
                      <div className="p-3 rounded text-center">
                          <h1><i className="text-primary"><Icon/></i></h1>
                          <div className="content">
                              <h5 className="title mt-3">{item.title}</h5>
                              <p className="text-muted mt-2 mb-0">{item.desc}</p>
                          </div>
                      </div>
                  </div>
              )
            })}
          </div>
      </div>

      <div className="container mt-100 mt-60">
          <div className="row">
              <div className="col-12 text-center">
                  <div className="section-title mb-5 pb-2">
                      <span className="badge bg-primary rounded-pill"> Latest Features </span>
                      <h4 className="title mt-3 mb-4">Great Services Provider</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>

          <div className="row align-items-center mt-4 pt-2">
              <div className="col-md-6">
                  <img src={fea1} className="img-fluid" alt=""/>
              </div>

              <div className="col-md-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <div className="row ms-md-5">
                      <div className="col-12">
                          <div className="pb-0 px-4 pt-4">
                              <h2><LiaRulerCombinedSolid className="float-start me-3 mt-3 text-primary"/></h2>
                              <div className="overflow-hidden d-block">
                                  <h5>Modern Workflow</h5>
                                  <p className="text-muted mb-0">Moreover, in Latin only words at the beginning of sentences are capitalized.</p>
                              </div>
                          </div>
                      </div>

                      <div className="col-12">
                          <div className="pb-0 px-4 pt-4">
                              <h2><BiBullseye className="float-start me-3 mt-3 text-primary"></BiBullseye></h2>
                              <div className="overflow-hidden d-block">
                                  <h5>Minimalism Feast</h5>
                                  <p className="text-muted mb-0">If the fill text is intended to illustrate the characteristics of sometimes.</p>
                              </div>
                          </div>
                      </div>

                      <div className="col-12 ps-5 pt-4">
                          <Link to="#" className="btn btn-outline-primary">Contact Now <i className="mdi mdi-chevron-right align-middle"></i></Link>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      
      <div className="container mt-100 mt-60">
          <div className="row align-items-center">
              <div className="col-md-6 order-1 order-md-2">
                  <img src={fea2} className="img-fluid" alt=""/>
              </div>

              <div className="col-md-6 order-2 order-md-1 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <div className="row me-md-5">
                      <div className="col-12">
                          <div className="pb-0 px-4 pt-4">
                              <h2><LuUser2 className="float-start me-3 mt-3 text-primary"/></h2>
                              <div className="overflow-hidden d-block">
                                  <h5>Customer Care</h5>
                                  <p className="text-muted mb-0">Moreover, in Latin only words at the beginning of sentences are capitalized.</p>
                              </div>
                          </div>
                      </div>
 
                      <div className="col-12">
                          <div className="pb-0 px-4 pt-4">
                              <h2><BsFonts className="float-start me-3 mt-3 text-primary"/></h2>
                              <div className="overflow-hidden d-block">
                                  <h5>Free Fonts</h5>
                                  <p className="text-muted mb-0">If the fill text is intended to illustrate the characteristics of sometimes.</p>
                              </div>
                          </div>
                      </div>

                      <div className="col-12 ps-5 pt-4">
                          <Link to="#" className="btn btn-outline-primary">Buy Now <i className="mdi mdi-chevron-right"></i></Link>
                      </div>
                  </div>
              </div>
          </div>
      </div>

      <div className="container mt-100 mt-60">
          <div className="row">
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                      <h4 className="title mb-4">Review From Customer's</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>

          <div className="row justify-content-center">
              <div className="col-md-10 mt-4 pt-2">
                  <ClientThree/>
              </div>
          </div>
      </div>

      <div className="container mt-100 mt-60">
          <div className="row justify-content-center">
              <div className="col-12 text-center">
                  <div className="section-title">
                      <h4 className="title mb-4">See everything about your employee at one place.</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  
                      <div className="mt-4">
                          <Link to="#" className="btn btn-primary mt-2 me-2">Get Started Now</Link>
                          <Link to="#" className="btn btn-outline-primary mt-2">Free Trial</Link>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </section>
    <FooterLight/>
    </>
  )
}
